import type { ApiResponse } from '@shared/api'

import { useAdminRoutes } from '@shared/lib/routes'

import { useKidStore } from '../model/store'

interface KidCustomerGoApiOptions {
  customerId: number
}

/**
 * The legacy kid page showed the customer's "Goal" label, but `kids/{kid}/details` does not carry
 * `is_go` — only `customers/{customer}/details` does. The label is decorative, so a failure stays silent.
 */
export const useKidCustomerGoApi = async (options: KidCustomerGoApiOptions): Promise<void> => {
  const { $axios } = useNuxtApp()
  const kidStore = useKidStore()

  const url = useAdminRoutes('admin.kid.customer.details', { customer_id: options.customerId })
  if (!url) return

  try {
    const { data } = await $axios.get<ApiResponse>(url)
    kidStore.setCustomerIsGo(data.success && data.data?.is_go === true)
  } catch (err: unknown) {
    console.error(err)
  }
}
